import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftDetailAutocompleteResponse } from '@/repositories/generated';

const response: GiftDetailAutocompleteResponse[] = [
  {
    id: '1',
    name: 'モック商品券詳細1',
  },
  {
    id: '2',
    name: 'モック商品券詳細2',
  },
  {
    id: '3',
    name: 'モック商品券詳細3',
  },
];

export const autocompleteGiftDetail = http.get(
  createMockEndpoint('/autocomplete/gift_detail'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
